import React from 'react';

import {
  Breakpoints,
  Offers,
  styled,
  useIsMobile,
} from '@vw-marketing/us-components';

const StyledContainer = styled.div`
  display: inline-block;
  position: relative;
`;

const StyledOffers = styled(Offers)`
  display: block;
  position: relative;
  z-index: 0;
`;

const StyledElipse = styled.div`
  background: #ffd100;
  border-radius: 50%;
  height: ${({isMobile}) => isMobile ? '10' : '20'}px;
  left: 0;
  position: absolute;
  top: 0;
  width: ${({isMobile}) => isMobile ? '10' : '20'}px;
  z-index: 1;
`;

export const OfferTag = () => {
  const isMobile: boolean = useIsMobile(Breakpoints.b960);

  return (
    <StyledContainer>
      <StyledElipse isMobile={isMobile}/>
      <StyledOffers variant={isMobile ? 'default' : 'large'} />
    </StyledContainer>
  );
};
